import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useState } from "react";
import { nl } from 'date-fns/locale';
import { Set } from 'immutable';
import DatePicker, { registerLocale } from "react-datepicker";
import { features } from '../../../../features';
import { isSmallViewport } from '../../../../utils/browser';
import { moment } from '../../../../utils/moment';
import { slugify } from '../../../../utils/string';
import { renderCalendarHeader } from '../../CalendarHeader';
import { pushEventAction } from '../../EventUtils';
registerLocale('nl', nl);
export const EventOverviewFilter = (props)=>{
    const { filterOptions, filterSettings: { regions, locations, tags, from, to }, filterUpdaters: { updateRegions, updateLocations, updateTags, updateDateRange, toggleFilterVisibility }, filterExpanded } = props;
    const config = features().events;
    if (config == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { locationFilter } = config.overviewPage;
    const push = pushEventAction();
    const smallViewport = isSmallViewport();
    const activeTags = Set(tags);
    const activeRegions = Set(regions);
    const activeLocations = Set(locations);
    const filterToggleText = filterExpanded ? 'Sluit filter' : 'Open filter';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            smallViewport && /*#__PURE__*/ _jsxs("button", {
                className: "a-filter__button button button--primary",
                "aria-controls": "filter-content",
                "aria-expanded": filterExpanded,
                onClick: ()=>{
                    push(filterToggleText);
                    toggleFilterVisibility();
                },
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "a-filter__button-icon",
                        width: 24,
                        height: 24,
                        "aria-hidden": "true",
                        children: filterExpanded ? /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--close",
                            width: 16,
                            height: 16,
                            x: 4,
                            y: 4
                        }) : /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--sliders-vertical"
                        })
                    }),
                    filterToggleText
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                id: "filter-content",
                className: "activities__filter a-filter",
                "aria-hidden": smallViewport ? !filterExpanded : null,
                children: [
                    locationFilter.kind == 'region' && /*#__PURE__*/ _jsxs("div", {
                        className: "a-filter__group",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "a-filter__group-title",
                                htmlFor: "activity-loc",
                                children: locationFilter.heading
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "a-filter__select form__select",
                                children: /*#__PURE__*/ _jsxs("select", {
                                    id: "activity-loc",
                                    onChange: (e)=>{
                                        e.preventDefault();
                                        push('filter-region', e.target.value || locationFilter.defaultLabel);
                                        updateRegions(e.target.value ? [
                                            e.target.value
                                        ] : []);
                                    },
                                    value: activeRegions.first() || '',
                                    children: [
                                        /*#__PURE__*/ _jsx("option", {
                                            value: '',
                                            children: locationFilter.defaultLabel
                                        }, "any-location"),
                                        filterOptions.regions.map((region)=>/*#__PURE__*/ _jsx("option", {
                                                value: region,
                                                children: region
                                            }, `region__${region}`))
                                    ]
                                })
                            })
                        ]
                    }),
                    locationFilter.kind == 'location' && /*#__PURE__*/ _jsxs("div", {
                        className: "a-filter__group",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "a-filter__group-title",
                                htmlFor: "activity-loc",
                                children: locationFilter.heading
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "a-filter__select form__select",
                                children: /*#__PURE__*/ _jsxs("select", {
                                    id: "activity-loc",
                                    onChange: (e)=>{
                                        e.preventDefault();
                                        push('filter-location', e.target.value || locationFilter.defaultLabel);
                                        updateLocations(e.target.value ? [
                                            e.target.value
                                        ] : []);
                                    },
                                    value: activeLocations.first() || '',
                                    children: [
                                        /*#__PURE__*/ _jsx("option", {
                                            value: '',
                                            children: locationFilter.defaultLabel
                                        }, "any-location"),
                                        filterOptions.locations.map((location)=>/*#__PURE__*/ _jsx("option", {
                                                value: location,
                                                children: location
                                            }, `location__${location}`))
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "a-filter__header",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "a-filter__group-title",
                                children: "Wanneer"
                            }),
                            from && to && /*#__PURE__*/ _jsx("button", {
                                className: "a-filter__reset",
                                onClick: ()=>updateDateRange(undefined, undefined),
                                children: "Wis selectie"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "a-filter__content",
                        children: /*#__PURE__*/ _jsx(WhenFilter, {
                            from: from,
                            to: to,
                            updateDateRange: updateDateRange,
                            push: push
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "a-filter__content",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "a-filter__group",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "a-filter__group-title",
                                    id: "tag-filter-title",
                                    children: "Onderwerp"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "a-filter__pills",
                                    role: "group",
                                    "aria-labelledby": "tag-filter-title",
                                    children: filterOptions.tags.map((tag)=>{
                                        const active = activeTags.has(tag);
                                        return /*#__PURE__*/ _jsx("button", {
                                            id: `tag-pill-${slugify(tag)}`,
                                            type: "button",
                                            className: `a-filter__pill${active ? ' a-filter__pill--active' : ''}`,
                                            "aria-pressed": active,
                                            onClick: ()=>{
                                                push(`filter-category-${active ? 'off' : 'on'}`, tag);
                                                updateTags((active ? activeTags.delete(tag) : activeTags.add(tag)).toArray());
                                            },
                                            children: tag
                                        }, `tag__${tag}`);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const WhenFilter = (props)=>{
    const { from, to, updateDateRange, push } = props;
    const now = new Date();
    const [startDate, setStartDate] = useState(from ?? null);
    const [endDate, setEndDate] = useState(to ?? null);
    // Sync local state when parent resets (e.g. "Wis alle filters").
    // Keyed on timestamps: from/to are re-parsed from the url into new Date objects on every render
    useEffect(()=>{
        setStartDate(from ?? null);
        setEndDate(to ?? null);
    }, [
        from === null || from === void 0 ? void 0 : from.getTime(),
        to === null || to === void 0 ? void 0 : to.getTime()
    ]);
    const handleChange = (dates)=>{
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (start && end) {
            const rangeFrom = moment(start).startOf('day').toDate();
            const rangeTo = moment(end).endOf('day').toDate();
            const daysSelected = Math.round((rangeTo.getTime() - rangeFrom.getTime()) / (1000 * 60 * 60 * 24));
            const daysFromNow = Math.round((rangeFrom.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
            push('filter-when', `from:${moment(start).startOf('day').format('X')};to:${moment(end).endOf('day').format('X')};daysSelected:${daysSelected};daysFromNow:${daysFromNow}`);
            updateDateRange(rangeFrom, rangeTo);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "a-filter__group",
        children: /*#__PURE__*/ _jsx(DatePicker, {
            locale: "nl",
            minDate: now,
            selectsRange: true,
            inline: true,
            startDate: startDate ?? undefined,
            endDate: endDate ?? undefined,
            onChange: handleChange,
            calendarClassName: "calendar",
            renderCustomHeader: renderCalendarHeader
        })
    });
};
